const sliderMain = document.querySelector('.slider-main');

const SLIDE_SPEED_FLIPPING_DELAY = 1000;
const SLIDE_SPEED_FLIPPING_DELAY_WITH_AUTO_PLAY = 2200;

const defaultSliderOptions = {
  watchOverflow: true,
  observer: true,
  resizeObserver: true,
  speed: SLIDE_SPEED_FLIPPING_DELAY,
  loop: true,
  navigation: {
    nextEl: '.js-slider-main-arrow-next',
    prevEl: '.js-slider-main-arrow-prev',
    enabled: false
  }
};

const initSlider = (elem) => {
  if (!elem) return;

  const countsElements = elem.querySelectorAll('.slider__main-item').length;
  const sliderOptions = {...defaultSliderOptions};

  if (countsElements > 1) {
    sliderOptions.effect = "fade";
    sliderOptions.fadeEffect = {
      crossFade: true
    };
    sliderOptions.loop = true;
    sliderOptions.navigation.enabled = true;
  }

  if (elem.hasAttribute('data-autoplay')) {
    sliderOptions.autoplay = {
      delay: SLIDE_SPEED_FLIPPING_DELAY_WITH_AUTO_PLAY,
      disableOnInteraction: false
    };
  }

  const swiper = new Swiper(elem, sliderOptions);
}

if (sliderMain) {
    initSlider(sliderMain);
}
